import React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface MapProps {
  address: string;
  zoom?: number;
  width?: string;
  height?: string;
  googleMapURL?: string;
  className?: string;
}

export const Map = ({
  address,
  zoom = 15,
  width = "100%",
  height = "500px",
  googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBMH3K1rDBFUa7jiBl0koDCnmcCBT5f5Zk&v=3.exp&libraries=geometry,drawing,places",
  className = "w-full h-[200px] md:h-[250px] rounded-lg",
}: MapProps) => {
  const { t } = useTranslation(["common", "contact"]);
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2036.1601374671077!2d18.15893687690171!3d59.30736491669055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465f7e0ca5c02c2d%3A0x7f53621d32d58e67!2sT%C3%A4ndkulev%C3%A4gen%2033%2C%20131%2051%20Nacka!5e0!3m2!1sen!2sse!4v1704374582566!5m2!1sen!2sse`;

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      <iframe
        src={mapUrl}
        className={`${className} map-iframe`}
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        title={t("map.title", { address })}
      />
    </div>
  );
};
